import { render, staticRenderFns } from "./LinkedinChannelDetail.vue?vue&type=template&id=a487e5b2&scoped=true"
import script from "./LinkedinChannelDetail.vue?vue&type=script&lang=js"
export * from "./LinkedinChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./LinkedinChannelDetail.vue?vue&type=style&index=0&id=a487e5b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a487e5b2",
  null
  
)

export default component.exports